import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const SocialMediaLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M4.712 9.31h2.923v10.189H4.712V9.309zm1.387-1.275h-.021c-1.059 0-1.745-.779-1.745-1.765 0-1.006.707-1.77 1.786-1.77 1.079 0 1.742.762 1.763 1.767 0 .987-.684 1.768-1.783 1.768zM19.333 19.5h-3.315v-5.274c0-1.38-.518-2.321-1.659-2.321-.872 0-1.357.635-1.583 1.248-.085.22-.071.526-.071.833V19.5H9.42s.043-9.341 0-10.19h3.285v1.599c.194-.7 1.243-1.697 2.918-1.697 2.078 0 3.71 1.466 3.71 4.621V19.5z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
